import authorizedAPIInstance from '@/api/authorizedAPI';
import type { Material } from '../utils/match-maker.types';
import { formatAPIError, replacePlaceholders } from '@/utils/helpers';
export type MaterialDetailInput = {
  id: string;
  plant?: number;
};
export const fetchMaterialDetail = async (
  params?: MaterialDetailInput
): Promise<Material> => {
  try {
    const { data } = await authorizedAPIInstance.get<Material>(
      replacePlaceholders(`/api/materials/:id`, {
        id: params?.id || '',
      }),
      {
        params: params || {},
      }
    );

    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};
